import { useEffect, useState } from "react";
import { api } from "./api.js";

export function ReferralAccounting() {
  const [summary,setSummary]=useState<{earned_kopecks:string;reversed_kopecks:string;approved_kopecks:string;pending_kopecks:string}|null>(null);
  const [error,setError]=useState(false);
  useEffect(()=>{
    let alive=true;
    void api<{summary:NonNullable<typeof summary>}>("/v1/me/referrals/details")
      .then(r=>{if(alive)setSummary(r.summary);}).catch(()=>{if(alive)setError(true);});
    return ()=>{alive=false;};
  },[]);
  const money=(v:string)=>`${(Number(v)/100).toLocaleString("ru-RU")} ₽`;
  if(error)return <p role="status">История начислений временно недоступна. Основной баланс показан выше.</p>;
  if(!summary)return <p role="status">Загружаем начисления…</p>;
  return <><div className="ref-stats"><span><strong>{money(summary.earned_kopecks)}</strong><small>начислено</small></span><span><strong>{money(summary.reversed_kopecks)}</strong><small>возвраты</small></span><span><strong>{money(summary.pending_kopecks)}</strong><small>ожидает выплаты</small></span></div><p>Подтверждённые выплаты: {money(summary.approved_kopecks)}. Начислено — сумма за всё время, а не доступный остаток.</p></>;
}
